var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.279053)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.2791,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#EDF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7138 45.1997C58.7488 44.1647 59.7763 41.7497 55.4638 44.6822C49.3363 48.9103 43.2969 52.8797 43.2969 52.8797C42.6752 53.1608 42.0031 53.3134 41.321 53.3282C40.6389 53.343 39.9608 53.2198 39.3275 52.9659C36.74 52.1897 33.7194 51.1547 33.7194 51.1547C33.7194 51.1547 31.6569 49.8591 35.1875 48.4791C35.1875 48.4791 50.1144 42.3535 55.2913 40.1953C57.275 39.3328 64.0044 36.5728 64.0044 36.5728C64.0044 36.5728 67.1113 35.3635 66.8525 38.2978C66.7663 39.5053 66.0763 43.7353 65.3863 48.3066C64.3494 54.7772 63.2282 61.8534 63.2282 61.8534C63.2282 61.8534 63.0557 63.8372 61.5894 64.1822C60.0198 64.1556 58.5033 63.6097 57.2769 62.6297C56.9319 62.3709 50.8063 58.4878 48.5619 56.5903C48.3336 56.4357 48.1481 56.2258 48.0227 55.9802C47.8973 55.7346 47.8361 55.4613 47.8447 55.1856C47.8533 54.91 47.9315 54.641 48.072 54.4037C48.2124 54.1665 48.4106 53.9685 48.6482 53.8284C51.7607 50.9822 55.4713 47.4441 57.7138 45.1997Z",
    fill: "#4C6FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventTelegram);
export default __webpack_public_path__ + "static/media/canvas_event_telegram.877fc56566b5ea735353df2bdff6a365.svg";
export { ForwardRef as ReactComponent };